const WHOOP_LS_PREFIX = 'whoop.security';
const WHOOP_LS_AUTH_TOKEN = `accessToken`;
const WHOOP_LS_USER = `user`;

const setItem = (name: string, content: string) => {
  window.localStorage.setItem(`${WHOOP_LS_PREFIX}.${name}`, content);
};

const getItem = (name: string) => {
  return window.localStorage.getItem(`${WHOOP_LS_PREFIX}.${name}`);
};

const removeItem = (name: string) => {
  window.localStorage.removeItem(`${WHOOP_LS_PREFIX}.${name}`);
};

export { setItem, getItem, removeItem, WHOOP_LS_AUTH_TOKEN, WHOOP_LS_USER };
